import { useEffect, useState } from 'react';

import { useRouter } from 'next/router';
import { SearchOutlined } from '@ant-design/icons';

import { TourTypes } from '@domain/tour/tourAutoComplate';
import SearchMonthDate from '@components/ui/search/SearchMonthDate';
import { YearTabProps } from '@components/ui/search/SearchMonthDate/interface';

import TourSelection from './tourSelection';
import { StyledButton, StyledLayout, StyledContent } from './styled';

const TourSearchBar = () => {
  const router = useRouter();

  const [dataTour, setDataTour] = useState<TourTypes>(null);
  const [href, setHref] = useState<string>('');
  const [isSubmit, setIsSubmit] = useState(false);

  const handleSubmit = () => {
    if (dataTour) {
      router.push(href ? href : (`/tur/${dataTour.url}` as string));
    }
    setIsSubmit(true);
  };

  const resetIsSubmit = () => {
    setIsSubmit(false);
  };

  const onHrefUpdate = (href: string) => {
    setHref(href);
  };

  const onDateMonthsUpdated = (info: YearTabProps[]) => {
    const [currentYear, nextYear] = info;

    const selectedItems: string[] = [];
    currentYear.months.forEach((item) => {
      if (item.checked) {
        selectedItems.push(`${currentYear.year}${item.number}`);
      }
    });

    nextYear.months.forEach((item) => {
      if (item.checked) {
        selectedItems.push(`${nextYear.year}${item.number}`);
      }
    });
    const currentHref = dataTour?.url?.split('?')?.[0];
    if (selectedItems.length === 0) return onHrefUpdate?.(currentHref || '');

    onHrefUpdate?.(`/tur/${currentHref}?date=${selectedItems.join('&date=')}`);
  };

  useEffect(() => {
    const baseUrl = href.split('?')?.[0];
    const selectedItems = href.split('?')?.[1];

    if (dataTour?.url && !!baseUrl && selectedItems) {
      onHrefUpdate(`/tur/${dataTour.url}` + '?' + selectedItems);
    }
  }, [dataTour?.url]);

  return (
    <StyledLayout>
      <StyledContent>
        <StyledContent>
          <TourSelection
            onChange={(value) => setDataTour(value)}
            isSubmit={isSubmit}
            resetIsSubmit={resetIsSubmit}
          />
          <SearchMonthDate
            onMonthsUpdated={onDateMonthsUpdated}
            inputComponent='shopAndFly'
          />
        </StyledContent>
        <StyledButton onClick={handleSubmit} data-testid='tourSearchButton'>
          <SearchOutlined />
          ARA
        </StyledButton>
      </StyledContent>
    </StyledLayout>
  );
};

export default TourSearchBar;
